import useAuthenticatedFetch from "./common/useAuthenticatedFetch";
import { ApiResponse } from "./models/ApiResponse";
import { Location } from "./models/Location";

export const useLocations = () => {
    const { response, isLoading } =
        useAuthenticatedFetch<ApiResponse<Location[]>>("api/locations");

    return {
        locations: response?.content ?? [],
        isLoading,
    };
};
